import { render, staticRenderFns } from "./skillDetail.vue?vue&type=template&id=2085ac2f&scoped=true"
import script from "./skillDetail.vue?vue&type=script&lang=js"
export * from "./skillDetail.vue?vue&type=script&lang=js"
import style0 from "./skillDetail.vue?vue&type=style&index=0&id=2085ac2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085ac2f",
  null
  
)

export default component.exports